import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import type { AudienceForm } from '../types';

export const useNormalizedDefinitionValidation = () => {
  const { trigger } = useFormContext<AudienceForm>();

  const triggerValidation = useCallback(() => {
    trigger('normalized_definition', { shouldFocus: true });
  }, [trigger]);

  const withValidation = useCallback(
    <T extends unknown[]>(updateFn: (...args: T) => void) => {
      return (...args: T) => {
        updateFn(...args);
        triggerValidation();
      };
    },
    [triggerValidation]
  );

  return { withValidation };
};
